import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    multiPolygonEditedCoordsState,
    multiPolygonEditedIDState,
    multiPolygonsInfoState,
    isUsingMeasuringToolState,
    mapTileUrlState,
} from '../../../../../../../app/redux/retrievers/retrievers';
import { theme } from '../../../../../../../core/theme/theme';
import { Polygon } from 'react-leaflet';
import { filterPolygonPointsByDistance } from '../../../../../../../core/utils/map.utils';
import { setMultiPolygonEditedCoords } from '../../../../../../../app/redux/slices/multiPolygonEditedCoordsSlice';
import { PolygonInfo } from '../../../../../../../core/types/types';

interface SingleMultiPolygonEditableProps {
    measuringToolDrawn: boolean;
}
const SingleMultiPolygonEditable: React.FC<SingleMultiPolygonEditableProps> = (measuringToolDrawn) => {
    const dispatch = useDispatch();
    const mapTileUrl = useSelector(mapTileUrlState);
    const singleMultiPolygonRef = useRef(null);
    const multiPolygonsInfo: PolygonInfo = useSelector(multiPolygonsInfoState);
    const multiPolygonEditedID = useSelector(multiPolygonEditedIDState);
    const multiPolygonEditedCoords = useSelector(multiPolygonEditedCoordsState);
    const isUsingMeasuringTool = useSelector(isUsingMeasuringToolState);

    let singleMultiPolygonCoords: any;
    let singleMultiPolygonId: number = 0;
    let singleMultiPolygonColor: string | undefined = '';
    let singleMultiPolygonOpacity: number | undefined = 0;

    multiPolygonsInfo.filter((polygon) => {
        if (polygon.polygonId === multiPolygonEditedID) {
            singleMultiPolygonId = polygon.polygonId;
            singleMultiPolygonCoords = polygon.polygonCoords;
            singleMultiPolygonColor = polygon.color;
            singleMultiPolygonOpacity = polygon.opacity;
        }
    });
    const [polygonKey, setPolygonKey] = useState(0);
    const polygonFilteredCoords =
        singleMultiPolygonCoords &&
        singleMultiPolygonCoords.length >= 3 &&
        filterPolygonPointsByDistance(singleMultiPolygonCoords);

    useEffect(() => {
        dispatch(setMultiPolygonEditedCoords([{ lat: 0, lng: 0 }]));
    }, [multiPolygonEditedID]);
    useEffect(() => {
        /*generate new key for polygon component each time coords are updated to fix editing bug*/
        setPolygonKey(polygonKey + 1 * Math.random());
    }, [mapTileUrl, multiPolygonEditedCoords, isUsingMeasuringTool, measuringToolDrawn]);

    // }
    return (
        <>
            <Polygon
                ref={singleMultiPolygonRef}
                key={polygonKey ? polygonKey : singleMultiPolygonId}
                positions={
                    multiPolygonEditedCoords.length >= 3
                        ? multiPolygonEditedCoords
                        : polygonFilteredCoords && polygonFilteredCoords.length >= 3
                        ? polygonFilteredCoords
                        : []
                }
                color={singleMultiPolygonColor ? singleMultiPolygonColor : theme.colors.garden_polygon_color}
                fillColor={singleMultiPolygonColor ? singleMultiPolygonColor : theme.colors.garden_polygon_color}
                fillOpacity={singleMultiPolygonOpacity ? singleMultiPolygonOpacity : 0}
                // eventHandlers={{
                //     click: () => {
                //         // setGardenDeletedID(innerPolygonId);
                //     },
                // }}
            />
        </>
    );
};

export default SingleMultiPolygonEditable;
